import { cn } from '@/shared/lib/cn';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  /** Ширина (CSS-значение или число px). По умолчанию 100%. *
 * @use заглушка на время загрузки, повторяющая форму будущего содержимого.
 */
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  circle?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const px = (v: string | number | undefined): string | undefined =>
  typeof v === 'number' ? `${v}px` : v;

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height,
  radius,
  circle,
  className,
  style,
}) => (
  <span
    className={cn(styles.skeleton, circle && styles.circle, className)}
    aria-hidden
    style={{
      width: px(width),
      height: px(height),
      borderRadius: circle ? '50%' : px(radius),
      ...style,
    }}
  />
);
